import { Link } from 'react-router-dom';
import { Bell, Search } from 'lucide-react';
import { useAuthStore } from '@/store/authStore';

export function MobileHeader() {
  const { user, isAuthenticated } = useAuthStore();

  return (
    <header className="mobile-header">
      <div className="mobile-header__content">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-primary to-secondary flex items-center justify-center shadow-lg shadow-primary/20">
            <span className="text-white font-bold text-lg">D</span>
          </div>
          <span className="font-bold text-xl gradient-text">
            Decixa
          </span>
        </Link>

        {/* Actions */}
        <div className="flex items-center gap-1">
          <Link
            to="/search"
            className="p-2 rounded-full hover:bg-slate-100 transition-colors"
          >
            <Search className="w-5 h-5 text-slate-600" />
          </Link>

          {isAuthenticated && (
            <Link
              to="/notifications"
              className="relative p-2 rounded-full hover:bg-slate-100 transition-colors"
            >
              <Bell className="w-5 h-5 text-slate-600" />
              <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-rose-500 rounded-full" />
            </Link>
          )}

          {isAuthenticated ? (
            <Link to="/profile" className="ml-1">
              <img
                src={user?.avatar || 'https://api.dicebear.com/7.x/avataaars/svg?seed=default'}
                alt={user?.displayName || 'Profile'}
                className="w-8 h-8 rounded-full object-cover ring-2 ring-white shadow"
              />
            </Link>
          ) : (
            <Link
              to="/login"
              className="ml-2 px-4 py-1.5 bg-primary text-white text-sm font-medium rounded-full"
            >
              Sign in
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
